import { Suspense, lazy, useState } from 'react'
import { observer } from 'mobx-react-lite'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { useAiAgentEnabled } from 'features/AiAgent/lib/flag'
import styles from 'features/AiAgent/ui/aiAgent.module.scss'

// Lazy so the Anthropic SDK + loop are not in the default bundle.
const ChatPanel = lazy(() => import('features/AiAgent/ui/ChatPanel'))

export const AiAgentLauncher = observer(() => {
  const enabled = useAiAgentEnabled()
  const { authStore } = useEntitiesContext()
  const [open, setOpen] = useState(false)
  // Once opened, keep the panel mounted (just hidden) so the chat survives close/reopen.
  const [hasOpened, setHasOpened] = useState(false)

  // Hide until the user is logged in (no agent on auth pages; tools need a user token).
  if (!enabled || !authStore.isLoggedIn) return null

  const toggle = () => {
    setOpen((v) => !v)
    setHasOpened(true)
  }

  return (
    <>
      {hasOpened && (
        <Suspense fallback={null}>
          <ChatPanel open={open} />
        </Suspense>
      )}
      <button type='button' className={styles.launcher} onClick={toggle}>
        {open ? 'Close' : 'Ask AI'}
      </button>
    </>
  )
})
